export default __webpack_public_path__ + "static/media/cross.inline.f60e2a4c.svg";